import { render } from "./TestsView.vue?vue&type=template&id=41701ec8&ts=true"
import script from "./TestsView.vue?vue&type=script&lang=ts"
export * from "./TestsView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\projects\\wintick\\wintick-applets-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__